<template>
  <div class="forms">
    <div class="h2">
      <a-radio-group v-model="kType" @change="resh(1)">

        <a-radio-button :value="0">新增沟通({{ top.talkData.total }})</a-radio-button>
        <!-- <a-radio-button :value="1">新增进度({{ top[1] }})</a-radio-button>
        <a-radio-button :value="2">新增债务人({{ top[2] }})</a-radio-button> -->
        <a-radio-button :value="3">新增邮寄({{ top.shipRemind.total }})</a-radio-button>
      </a-radio-group>
      <div class="mid">
        <a-row style="display:flex;align-items: center;">
          <a-col class="flex" v-if="kType == 0" style="margin-right: 20px;">
            <label>沟通人员：</label>
            <a-select style="min-width: 160px;" v-model="user_id" placeholder="请选择" class="nselect" show-search
              allowClear option-filter-prop="children" :filter-option="filterOption" @change="resh">
              <a-select-option v-for="i in top.optionList" :key="i.id">{{ i.uname }}</a-select-option>
            </a-select>
          </a-col>
          <a-col class="flex">
            <a-radio-group name="radioGroup" v-if="kType == 3" v-model="type" @change="resh" size="small">
              <a-radio :value="0">立案材料({{ top.shipRemind.register }})</a-radio>
              <a-radio :value="1">接收材料({{ top.shipRemind.accept }})</a-radio>
              <a-radio :value="2">补充材料({{ top.shipRemind.supp }})</a-radio>
            </a-radio-group>
            <a-radio-group name="radioGroup" v-if="kType == 0" v-model="type" @change="resh" size="small">
              <a-radio :value="0">判决前沟通({{ top.talkData.talkCount }})</a-radio>
              <a-radio :value="1">执行前沟通({{ top.talkData.talkAfterJudCount }})</a-radio>
              <a-radio :value="2">执行后沟通({{ top.talkData.talkExecCount }})</a-radio>
            </a-radio-group>
          </a-col>
        </a-row>
        <div class="find">
          <a-popconfirm title="确认批量已读吗?" ok-text="确定" cancel-text="取消" @confirm="read(1, ids)" v-if="ids.length > 0">
            <a-button class="blu">批量已读</a-button>
          </a-popconfirm>
          <a-button @click="() => { this.$message.warning('请先勾选内容') }" class="blu" v-else>批量已读</a-button>

        </div>
      </div>
    </div>
    <div class="table" v-if="load">
      <Table :formKey="tableKey" :getUrl="putData.url[kType]" v-if="$common.AUTH(seePower)" :ID="id" ref="table"
        :hasCk="true" :query="query" @putCk="
          (e) => {
            ids = e
          }
        " :other="['cause', 'id', 'debtor_id']">
        <template v-slot:pick="v">
          <div class="fbtns">
            <span v-if="$common.AUTH('debtor:info')">
              <router-link :to="{
                name: 'lydetails',
                params: {
                  id:
                    kType == 0
                      ? v.other[0].debtor_id
                      : kType == 3
                        ? v.other[2]
                        : v.id,
                },
              }" class="curpoter" target="_blank" style="color: #1d8bfe">
                查看</router-link>
            </span>
            <span v-else> 查看 </span>
            <span @click="
              read(
                0,
                (kType == 0 && type == 2) || kType == 1 ? v.other[1] : v.id
              )
              ">标为已读</span>
          </div>
        </template>
      </Table>
      <div class="nqx smnq" v-else>
        您没有该页面的访问权限，请联系管理员开通。
      </div>
    </div>
  </div>
</template>
<script>
import Table from './table.vue'
import { wread } from '@/server/api'
import { ajax } from '@/assets/js/ajax.js'
import { accUserList } from '@/server/user'
export default {
  name: 'His',
  props: { putData: Object, NumList: Array },
  data() {
    return {
      user_id: undefined,
      userList: [],
      ids: [],
      type: 0,
      // Email: [],
      // NumsList: [],
      load: true,
      kType: 0,
    }
  },
  components: { Table },
  computed: {
    seePower() {
      if (this.kType == 0) {
        return [
          'welcome:new:communicate:cause',
          'welcome:new:communicate:beforExec',
          'welcome:new:communicate:InExec',
        ][this.type]
      } else {
        return 'welcome:email'
      }
    },
    id() {
      return this.kType == 1 || (this.kType == 0 && this.type == 2)
        ? 'debtor_id'
        : 'id'
    },
    top() {
      return this.$store.state.Home.Top
    },
    query() {
      // <a-radio :value="0">立案材料({{Email[0]}})</a-radio>     1
      //     <a-radio :value="1">接收材料({{Email[1]}})</a-radio>  3
      //     <a-radio :value="2">补充材料({{Email[2]}})</a-radio>  2
      //
      //      <a-radio :value="0">接收材料({{Email[2]}})</a-radio>  3
      //     <a-radio :value="1">补充材料({{Email[1]}})</a-radio>     2
      //     <a-radio :value="2">其他({{Email[0]}})</a-radio> --> 1

      if (this.kType == 0) {
        return { connect_type: this.type + 1, user_id: this.user_id }
      } else if (this.kType == 3) {
        if (this.type == 0) {
          return {
            source: 1,
          }
        } else if (this.type == 1) {
          return {
            source: 3,
          }
        } else {
          return {
            source: 2,
          }
        }
      } else {
        return {}
      }
    },
    tableKey() {
      // if(this.kType!=0) return this.putData.formKey[this.kType]
      // else{
      //   if(this.kType==3)
      // }
      return this.kType != 0 ? this.putData.formKey[this.kType] : this.putData.formKey[0][0]
    },
  },
  created() {
    // this.getNums()
    // accUserList(this.$store.state.user.id > 1 ? { title: this.$store.state.user.title, is_inner: 1 } : { is_inner: 1 }).then((res) => {
    //   this.userList = res.list
    // })
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getNums() {
      // let getCodeList = (v) => {
      //   //公共 调用
      //   return new Promise((resolve, reject) => {
      //     ajax({
      //       url: v.url, //url
      //       type: 'get',
      //       success: (e) => {
      //         // 判断是否有权限，没有为0
      //         resolve(this.$common.AUTH(v.key) ? e.count : 0)
      //       },
      //     })
      //   })
      // }
      // let getAllo = async () => {
      //   //循环抛请求
      //   let result = await Promise.all(
      //     [
      //       {
      //         url: 'shipRemind/index?source=1',
      //         key: 'welcome:email',
      //       },
      //       {
      //         url: 'shipRemind/index?source=2',
      //         key: 'welcome:email',
      //       },
      //       {
      //         url: 'shipRemind/index?source=3',
      //         key: 'welcome:email',
      //       },
      //     ].map((ele) => {
      //       return getCodeList(ele)
      //     })
      //   )
      //   return result
      // }
      // ajax({
      //   url: 'cause/comments/groupCount', //url
      //   type: 'get',
      //   success: (e) => {
      //     this.NumsList = [e.talkCount, e.talkAfterJudCount, e.talkExecCount]
      //   }
      // })
      // getAllo().then((result) => {
      //   this.Email = result
      // })
    },
    async resh(like) {
      let p = (bool) => new Promise((resolve, reject) => {
        this.load = bool
        resolve()
      })
      this.ids = []
      if (this.kType == 3) {
        this.getNums()
      }
      if (like == 1) {
        await p(false)
        this.type = 0
        await p(true)
        // this.$refs.table.resh()
        return
      }
      await p(false)
      await p(true)
    },
    read(type, v) {
      if (type == 1 && v.length == 0) return false
      wread(v, this.kType, this.type).then((e) => {

        this.$message.success('已标记已读')
        this.$store.dispatch('Home/seth')
        this.ids = []
        this.$refs.table.resh()
        this.getNums()
        this.$store.dispatch('Home/getKey', this.NumList)
      })
    },
  },
}
</script>
<style lang="less" scoped>
.h2 {
  display: flex;
}

.mid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 26px;
  flex: 3;

  .find {
    display: flex;
    align-items: center;

    /deep/.input {
      width: 132px;
      height: 30px;

      input {
        padding: 4px 8px;
        height: 30px;
        font-size: 13px;
        line-height: 30px;
      }
    }

    /deep/.ant-btn {
      height: 30px;
      margin-left: 18px;
    }
  }
}
</style>